import { Utils } from "../../utils"
import api from "../api"

export class ClientsService {
    static pathBase = "/users/clients/"

    static async verifyEnterpriseOwnerShip(body: {
        cpf: string,
        cnpj: string,
        birthday: string
    }) {
        return api.post(this.pathBase + "verify-enterprise-ownership", body)
    }

    static async create(body: {
        cpf: string,
        cnpj: string,
        email: string,
        indicatedBy?: string
        data: {
            birthday: string,
            phone: string,
            address: {
                street: string,
                number: string,
                district: string,
                city: string,
                cep: string,
                uf: string,
                complement?: string,
                reference?: string,
            }
        },
        createAsBlocked: boolean

    }) {
        return api.post(this.pathBase, body)
    }

    static async simulator(value: number, excludeSaturday?: boolean) {
        return api.get(`/contracts/simulator/${value}${excludeSaturday ? "?exclude_saturday=true" : ""}`)
    }

    static async uploadDocument(document: File) {
        const data = new FormData()
        data.append("comprovante", document)

        return api.post(this.pathBase + "verify", data)
    }

    static async createContract(body: {
        payTo: "cpf" | "cnpj",
        value: number,
        includeSaturday: boolean
    }) {
        return api.post("/contracts", body)
    }

    static async getCNPJ(cnpj: string) {
        return api.get(`/enterprise-data/${Utils.onlyDigits(cnpj)}`)
    }

    static async generateCodePayment(body: {
        contractId: number,
        parcel: number,
    }) {
        return api.post("/contracts/parcels/qrcode", body)
    }

    static async checkPaymentStatus(id: number) {
        return api.get(`/finance/receipts/` + id)

    }

    static async markAsReadedContractReason(id: number) {
        return api.patch(`/contracts/mark-as-readed-reason/${id}`)
    }

    static async verifyCEP(cep: string) {
        return api.get(this.pathBase + `zone/${Utils.onlyDigits(cep)}`)
    }

    static async checkSMSCode(code: string) {
        return api.post(this.pathBase + "test-sms-key/" + code)
    }

    static async checkPINCode(code: string) {
        return api.post(this.pathBase + "test-key/" + code)
    }

    static async updatePhone(phone: string) {
        return api.patch(this.pathBase + "update-phone/" + phone)
    }

    static async uploadPhoto(data: FormData) {
        return api.post(this.pathBase + "upload-photos", data)
    }

    static async uploadBusinessPhotos(contractId: number, data: FormData) {
        return api.post("/contracts/upload-photos/" + contractId, data)
    }

    static async createPartner(body: {
        cpf: string,
        cnpj: string,
        email: string,
        indicatedBy?: string
        data: {
            birthday: string,
            phone: string,
        },
    }) {
        return api.post("/users/partners/", body)
    }

    static async updateBusinessActivity(body: {
        workdays: number[],
        workDescription: string
    }) {
        return api.patch("/users/clients/complement", body)
    }
}